import { ApolloClient, NormalizedCacheObject, useQuery } from '@apollo/client';
import { XApiLaunchUrlData, XApiLaunchUrlVars } from '../gql-types';

import ApolloClientService from '../../shared/services/ApolloClientService';
import Config from '../../shared/config';
import GraphQL from '../gql';
import ProgressStatusCode from '../models/ProgressStatusCode';

let dashboardApolloClient: ApolloClient<NormalizedCacheObject> = null;

function useXApiLessons(
  lessonkey: number,
  lessonVersion: number,
  status: ProgressStatusCode,
  layer: number,
  preview: boolean = false
) {
  if (!dashboardApolloClient) {
    dashboardApolloClient = ApolloClientService.create(Config.DASHBOARD_GQL);
  }

  const { loading, error, data } = useQuery<
    XApiLaunchUrlData,
    XApiLaunchUrlVars
  >(GraphQL.Query.XAPI_LAUNCH_URL, {
    client: dashboardApolloClient,
    variables: {
      lessonkey,
      lessonVersion,
      status,
      layer,
      preview
    }
  });

  return {
    loading,
    error: !!error,
    url: data?.xApiLaunchUrl
  };
}

export default useXApiLessons;
